import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({providedIn:'root'}) export class DadosMilitaresService {
 constructor(private http:HttpClient){}
 hipoteses(){return this.http.get<any[]>(`${environment.URL_API}/checklist-militar`); }
 buscar(matricula:string,idOrgao:number){return this.http.get<any>(`${environment.URL_API}/dados-militares`,{params:{matricula,idOrgao}});}
 salvar(matricula:string,idOrgao:number,dados:any){return this.http.put<any>(`${environment.URL_API}/dados-militares`,dados,{params:{matricula,idOrgao}});}
}
